import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { ExtractTasks } from '~src/extractTask/resources/ExtractTasks';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ExtractTaskContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getGenericDefaultFilters } from '../../../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const ExtractTaskDefinition: ExplorableItemDefinition = {
  itemType: 'extractTask',
  pluralName: Messages.extractTasks,
  singularName: Messages.extractTask,
  emptyStateMessage: Messages.extractTasksEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconType: null,
  filterClause: ServerFilterClauses.ContentType(['extractTask']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return ExtractTasks.all().withExtraParams(ExtractTaskContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
